<template>
  <pt-scan-payment-counselor ref="table" class="pt-scan-payment-counselor__withData" :orderOrganization="orderOrganization" @exportAllOrder="exportAllOrder"
                             :exportLoading="exportLoading" @refundOrder="refundOrder" :isLifeExperienceHall="isLifeExperienceHall" :isScanPaymentStorage="isScanPaymentStorage">
  </pt-scan-payment-counselor>
</template>

<script>
import PtScanPaymentCounselor from './index'
export default {
  name: 'pt-scan-payment-counselor__withData',
  components: {
    'pt-scan-payment-counselor': PtScanPaymentCounselor
  },
  computed: {
    isLifeExperienceHall () {
      return this.$route.name === 'scan-payment-life-experience-hall'
    },
    isScanPaymentStorage () {
      return this.$route.name === 'scan-payment-storage'
    }
  },
  data () {
    return {
      orderOrganization: [],
      exportLoading: false
    }
  },
  methods: {
    refundOrder (row) {
      this.$set(row, 'refundLoading', true)
      this.$store.dispatch('refundPaymentOrder', row.id).then(res => {
        this.$message.success('退款成功')
        this.$set(row, 'refundSuccess', true)
        this.$refs.table.getTableData()
        this.$set(row, 'refundLoading', false)
      }).catch(err => {
        this.$set(row, 'refundLoading', false)
        this.$message.error(err || '汇款失败')
      })
    },
    // 获取分子公司列表
    getorderOrganization () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        this.orderOrganization = res.data
      }).catch(err => {
        this.$message.error(err || '获取分子公司列表失败')
      })
    },
    exportAllOrder (data) {
      this.exportLoading = true
      let api = 'exportConsultantPaymentOrders'
      switch (this.$route.name) {
        case 'scan-payment-life-experience-hall':
          api = 'exportLifeExperienceHallPaymentOrders'
          break
        case 'scan-payment-storage':
          api = 'exportLifeStoragePaymentOrders'
          break
        case false:
          api = 'exportConsultantPaymentOrders'
          break
      }
      // let api = this.isLifeExperienceHall ? 'exportLifeExperienceHallPaymentOrders' : 'exportConsultantPaymentOrders'
      this.$store.dispatch(api, data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出缴费订单失败')
      })
    }
  },
  created () {
    this.getorderOrganization()
  }
}
</script>
